import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../lib/apiClient.js';
import { queryKeys } from '../../lib/queryKeys.js';
import type { User } from '../../lib/types.js';

interface UserDetailLogic {
  isLoading: boolean;
  data: User | undefined;
  error: Error | null;
}

/** One user with their direct scopes, effective scopes, and group memberships. */
export const useUserDetailLogic = (
  tenantId: string | undefined,
  userId: string | undefined,
): UserDetailLogic => {
  const query = useQuery<User>({
    queryKey: queryKeys.user(tenantId ?? '', userId ?? ''),
    queryFn: () => apiRequest<User>(`/api/users/${userId}`),
    enabled: Boolean(tenantId && userId),
  });

  return {
    isLoading: query.isLoading,
    data: query.data,
    error: query.error,
  };
};
